import uuid from 'uuid/v1'

import * as excelConstants from '../../../constants/General/Excel'
import { updateTab , addActionInTab} from "../../Tabs"

export const addSetRangeColor = (parentId = null) => {
  return (dispatch, getState) => {
    let { tabs, currentTab } = getState()
    let tab = tabs[currentTab]
    let path = ''
    // please refer to the appendRange.js
    if(parentId){
      let parentAction =  tab["actions"][parentId]
      if(parentAction.type==='OPEN_SPREADSHEET'){
        path = parentAction.path
      }
    }
    let action = {
      id : uuid(),
      type : excelConstants.SET_RANGE_COLOR,
      parentId : parentId,
      label : "Set Range Color",
      key : "setrangecolor",
      allowNesting: false,
      path : path,
      sheetName:"",
      color : "",
      range : "",
      variableName : '',
      instruction : "",
      description : "",
      status:false,
      breakpoint:false
    }
    tab = addActionInTab(tab, action, parentId)
    dispatch(updateTab(tab))
  }
}

export const editSetRangeColor = (payload,actionId=null) => {
  return (dispatch, getState) => {
    // let { tabs, currentTab } = getState()
    // let tab = tabs[currentTab]
    // // please refer to the appendRange.js
    // let excelAction = tab["actions"][actionId ? actionId : tab.currentAction]
    // let temp = {
    //   ...excelAction,
    //   ...payload
    // }
    // if((temp.path!=""&&temp.path!=".")&&temp.sheetName&&temp.range&&temp.color!=""){
    //   temp.status=true
    // }else{
    //   temp.status=false
    // }
    // let instruction = `api_config = {method:'POST', header:['Content-Type: application/json','Accept: application/json'], body:{'filePath':'${temp.path}','sheetName':'${temp.sheetName}','range':'${temp.range}','color':'${temp.color}'}}
    //                    api ${remote.process.env.RPA_PYTHON_API}/api/v1/color
    //                    echo api_json.data`
    // tab["actions"][actionId ? actionId : tab.currentAction] = {
    //   ...temp,
    //   instruction : instruction,
    //   description : `set ${temp.color} for ${temp.range} of ${temp.sheetName} in ${temp.path}`
    // }
    // dispatch(updateTab(tab))
  }
}
